import { Plus } from "@/icons"
import { ButtonLink, Icon } from "@/components/ui"

/** Quiet dashed row back to the menu, below the bag lines. */
export default function AddMoreItemsButton() {
  return (
    <ButtonLink to="/" variant="dashed-soft" tone="secondary" size="md" weight="semibold" fullWidth>
      <Icon as={Plus} size="md" weight="bold" />
      Adicionar mais itens
    </ButtonLink>
  )
}
